import React, { useEffect, useState, Fragment } from "react";
import { handleDate } from "../../functions/handleDate";
import {ShortCutDate} from "../../functions/ShortCutDate";
import {getDispositivi} from "../../const/CardDati";
import { Grid, Button, Divider, TextField, Autocomplete, Checkbox } from "@mui/material";
import { FormControl, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import { CDCard, CDCardContent, CDCardHeader } from "../../const/CDCardStyles";
import DateTimePicker from '@mui/lab/DateTimePicker';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CircularProgress from '@mui/material/CircularProgress';
import styles from './FilterPanel.module.css';
import { calcPrevMonthDate } from "../../functions/ShortCutDate";
import axios from "axios";

let today = new Date();
const url = process.env.REACT_APP_URL;
const resultDate = calcPrevMonthDate(today);
const action = getDispositivi.action;

function FilterPanel({ isFetching, handleDateToFilterDate }) {

  const [RadioButtonValue, setRadioButtonValue] = useState();
  const [startDate, setStartDate] = useState(resultDate.beginDate);
  const [endDate, setEndDate] = useState(resultDate.endDate);
  const [isRangeDateValid, setIsRangeDateValid] = useState({
    errorMsg: [],
    isCorrectRangeData: true,
    startDate: startDate,
    endDate: endDate
  });

  const [inputDeviceSelect, setInputDeviceSelect] = useState('');
  const [selectedDevice, setSelectedDevice] = useState([]);
  const [isSelectOpen, setIsSelectOpen] = useState(false);
  const [selectOptions, setSelectOptions] = useState([]);
  const loadingState = isSelectOpen && selectOptions.length === 0;
  
  
  const RadioButtonChangeValue = (event) => {
    setRadioButtonValue(event.target.value);
  };
  
  // handle input change event
  const handleInputChange = (event, value) => {
    setInputDeviceSelect(value);
  };

  // handle selection
  const handleChange = (event, value) => {
    setSelectedDevice(value);
  };

  const loadOptions = () => {
    (async (a) => {
      const response = await axios(inputDeviceSelect ? url + `${ action +'?filter=' + inputDeviceSelect}` : url + action);
       setSelectOptions(response.data.result);
    })();
  };

  useEffect(() => {
    
    if (RadioButtonValue) {
      let shortcutDate = ShortCutDate(RadioButtonValue);
      setStartDate(shortcutDate?.begin);
      setEndDate(shortcutDate?.end);
    }
  }, [RadioButtonValue]);
  
  useEffect(() => {
    setIsRangeDateValid(handleDate(startDate, endDate));
  }, [startDate, endDate]);
  
  
  useEffect(() => {
    let active = true;
    
    if (!loadingState) {
      return undefined;
    }
    
    (async () => {   
      if (active) {
         loadOptions();
      }
    })();

    return () => {
      active = false;
    };

  }, [loadingState]);


  return (
    <>
        <Grid container item>
          <Grid item component={CDCard} xs={12} sm={12}>
              <CDCardHeader title="Filtri" />
              <Divider />
              <CDCardContent>
                  <Grid container columnSpacing={3} rowSpacing={2}>
                      <Grid container item>
                          <FormControl component="fieldset">
                              <RadioGroup row aria-label="dateRange" name="row-radio-group" onChange={RadioButtonChangeValue} defaultValue="ultimoMese">
                                  <FormControlLabel value="ultimoMese" control={<Radio />} label="Ultimo Mese" />
                                  <FormControlLabel value="ultimaSettimana" control={<Radio />} label="Ultima Settimana" />
                                  <FormControlLabel value="meseCorrente" control={<Radio />} label="Mese Corrente" />
                              </RadioGroup>
                          </FormControl>
                      </Grid>
                      <Grid container item columnSpacing={3} rowSpacing={2}>
                          <Grid item xs={12} sm={6} md={3}>
                              <DateTimePicker
                                label="Dal"
                                value={startDate}
                                onChange={(newDate) => {
                                  setStartDate(newDate);
                                }}
                                maxDate={today}
                                renderInput={(params) => <TextField {...params} id="fromDate" variant="standard" size="small" inputProps={{...params.inputProps, placeholder: 'gg/mm/aaaa'}} fullWidth/>}
                              />
                          </Grid>
                          <Grid item xs={12} sm={6} md={3}>
                            <DateTimePicker
                                label="Al"
                                value={endDate}
                                onChange={(newDate) => {
                                  setEndDate(newDate);
                                }}
                                minDate={startDate}
                                maxDate={today}
                                renderInput={(params) => <TextField {...params} id="toDate" variant="standard" size="small" inputProps={{...params.inputProps, placeholder: 'gg/mm/aaaa'}} fullWidth/>}
                              />
                          </Grid>
                          <Grid item xs={12} sm={12} md={6}>
                            <FormControl fullWidth>
                              <Autocomplete
                                multiple
                                id="devices"
                                size="small"
                                open={isSelectOpen}
                                onOpen={() => {
                                  setIsSelectOpen(true);
                                }}
                                onClose={() => {
                                  setIsSelectOpen(false);
                                }}
                                loading={loadingState}
                                options={selectOptions}
                                value={selectedDevice}
                                disableCloseOnSelect
                                limitTags={1}
                                getOptionLabel={(option) => option.denominazione}
                                onChange={handleChange}
                                onInputChange={handleInputChange}
                                renderOption={(props, option, { selected }) => (
                                  <li {...props}>
                                    <Checkbox
                                      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                      checkedIcon={<CheckBoxIcon fontSize="small" />}
                                      style={{ marginRight: 8 }}
                                      checked={selected}
                                    />
                                    {option.denominazione}
                                  </li>
                                )}
                                renderInput={(params) => (
                                  <TextField {...params} label="Dispositivi" variant="standard" InputProps={{
                                      ...params.InputProps,
                                      endAdornment: (
                                        <Fragment>
                                          {loadingState ? <CircularProgress color="inherit" size={20} /> : null}
                                          {params.InputProps.endAdornment}
                                        </Fragment>
                                      ),
                                    }}
                                  />
                                )}
                              />
                            </FormControl> 
                          </Grid>
                      </Grid>
                      <Grid container item>
                        <Grid item xs={12} className={styles.buttonGrid}>
                            <Button variant="contained" disabled={isFetching} className={styles.buttonStyle} onClick={() => {
                                handleDateToFilterDate(isRangeDateValid,selectedDevice);
                              }}>Applica</Button>
                        </Grid>
                      </Grid>
                  </Grid>
              </CDCardContent>
          </Grid>
        </Grid>
    </>
  );
}

export default FilterPanel;
